import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { IBaseSearchRequest, IPagedResults } from 'src/app/core/models/base';
import { environment } from 'src/environments/environment';
import { ICreateCompanyRequest, ICompany, IUpdateCompanyRequest, ISearchCompanyRequest, ICompanySettings, IUpdateCompanySettingsRequest } from '../models/company';

@Injectable({
  providedIn: 'root'
})
export class CompanyService {

  constructor(private http: HttpClient) { }

  getCompany(companyId: string){
    return this.http.get<ICompany>(
      `${environment.baseUrl}/v1/companies/getCompany/${companyId}`
    )
  }

  listCompanies(request: ISearchCompanyRequest){
    return this.http.post<IPagedResults<ICompany[]>>(
      `${environment.baseUrl}/v1/companies/searchCompanies`,
      request
    )
  }

  createCompany(request: ICreateCompanyRequest){
    return this.http.post<ICompany>(
      `${environment.baseUrl}/v1/companies/createCompany`,
      request
    )
  }

  updateCompany(request: IUpdateCompanyRequest){
    return this.http.put<ICompany>(
      `${environment.baseUrl}/v1/companies/updateCompany/${request.id}`,
      request,
    )
  }

  updateCompanySettings(request: IUpdateCompanySettingsRequest){
    return this.http.put<ICompanySettings>(
      `${environment.baseUrl}/v1/companies/updateCompanySettings/${request.id}`,
      request,
    )
  }

  deleteCompany(id: string){
    return this.http.delete<string>(
      `${environment.baseUrl}/v1/companies/deleteCompany/${id}`
    )
  }
}
